import { render, staticRenderFns } from "./LiveConsult.vue?vue&type=template&id=360b17bf"
import script from "./LiveConsult.vue?vue&type=script&lang=js"
export * from "./LiveConsult.vue?vue&type=script&lang=js"
import style0 from "./LiveConsult.vue?vue&type=style&index=0&id=360b17bf&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports